<template>
    <md-dialog :md-active.sync="showDialog" :md-close-on-esc="true" :md-click-outside-to-close="true">
        <div class="net-promoter-wrapper">
            <md-dialog-title>
                <p class="md-subheading">How likely are you to reccomend EarthBlox to a friend or colleague?</p>
            </md-dialog-title>
            <md-dialog-content>
                <form>
                    <p class="md-body-1">Where <span class="md-body-2">0</span> is not likely at all and <span class="md-body-2">10</span> is extremely likely.</p>
                    <div>
                        <md-radio v-model="radio" :value="0">0</md-radio>
                        <md-radio v-model="radio" :value="1">1</md-radio>
                        <md-radio v-model="radio" :value="2">2</md-radio>
                        <md-radio v-model="radio" :value="3">3</md-radio>
                        <md-radio v-model="radio" :value="4">4</md-radio>
                        <md-radio v-model="radio" :value="5">5</md-radio>
                        <md-radio v-model="radio" :value="6">6</md-radio>
                        <md-radio v-model="radio" :value="7">7</md-radio>
                        <md-radio v-model="radio" :value="8">8</md-radio>
                        <md-radio v-model="radio" :value="9">9</md-radio>
                        <md-radio v-model="radio" :value="10">10</md-radio>
                    </div>
                    <md-button type="submit" class="md-primary md-raised" @click="submitScore()">Submit score</md-button>
                </form>
            </md-dialog-content>

    </div>
    </md-dialog>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
    import { AuthService } from "@/services/auth.service"
    import { organisationsCollection } from "@/firebase.js"
    import firebase from 'firebase/app'
    import 'firebase/firestore';
    import { AnalyticsService } from "@/services/analytics.service";
    import { GA_EVENTS } from "@/constants/gaConstants.js";

    export default {
        name: 'NetPromoterSurvey',
        data: () => ({
            user: null,
            radio: false,
            showDialog: false,
            userData: {},
            responseData: {},
            surveyStatus: '',
            userId: '',
            responsesCollections: {},
            project: '',
            initialNPS: '',
            ongoingNPS: ''
        }),
        created() {
            let self = this;
            this.subscription = AuthService.loggedUser$.subscribe((user) => {
                self.user = user;
            });

            this.userId = this.user.uid;

            organisationsCollection.doc(this.user.orgId).get().then(doc => {
                this.project = doc.data().name;
                this.initialNPS = doc.data().initialNPS;
                this.ongoingNPS = doc.data().ongoingNPS;
            });

            // default object to store for new user with no NPS history
            this.userData = {
                loginCounter: 1,
                responseCounter: 0,
                npsStatus: ''
            };

            // get the userResponses collection from firebase organisation
            this.responsesCollections = this.responsesRef;

        },
        beforeDestroy() {
            this.subscription.unsubscribe();
        },
        methods: {
            submitScore: function() {
                this.showDialog = false;

                // response data to be recorded
                this.responseData = {
                    uid: this.user.uid,
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    score: this.radio,
                    orgId: this.user.orgId,
                    projectId: this.project,
                    role: this.user.roles
                }
                //update firebase with response
                this.updateUserStats(this.userId, this.userData, this.responseData);
            },
            updateUserStats: function(id, data, responseData) {
                // update firebase when user submits a score
                this.responsesCollections.doc(id).get(data).then(doc => {
                    doc.ref.update({
                        loginCounter: 0,
                        npsStatus: 'responded',
                        responseCounter: firebase.firestore.FieldValue.increment(1)
                    });
                    data.loginCounter = 0
                    data.npsStatus = 'responded';
                });

                AnalyticsService.logAnalyticsEvent(GA_EVENTS.NET_PROMOTER_RESPONSE);
                this.responsesCollections.doc(id).collection('responses').add(responseData);
            }
        },
        computed: {
            responsesRef() {
                const orgId = this.user.orgId;
                return organisationsCollection.doc(orgId).collection('stats').doc('netPromoterQuestion').collection('userResponses');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .md-dialog .net-promoter-wrapper {
        text-align: center;
        background-color: #f1a73d;
    }
    .md-dialog.net-promoter-dialog .md-dialog-container {
        border-radius: 10px;
    }
    .md-dialog .md-dialog-content {
        background-color: #fff;
        padding-top: 14px;
    }
    .net-promoter-wrapper .md-dialog-title {
        color: white;
        margin: 0;
        padding: 0;
    }
    .net-promoter-wrapper .md-button {
        margin: 0;
        margin-top: 10px;
    }
</style>
